import CrossIcon from "Assets/Icons/CrossIcon";
import Typography from "Components/CommonComponents/Typography";
import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const CustomModal = (props: any) => {
  return (
    <React.Fragment>
      <Modal
        zIndex={105000}
        isOpen={props.modal}
        toggle={props.toggle}
        backdrop={props.backdrop}
        centered={props.centered}
        size={props.size ? props.size : "lg"}
        fullscreen={props.fullscreen ? props.fullscreen : false}
        className={["NewModalCSS", props.className].filter(Boolean).join(" ")}
      >
        <ModalHeader
          onContextMenu={(e) => e.preventDefault()}
          cssModule={{ "modal-title": "d-flex flex-row w-100" }}
        >
          <div className="modal-header-custom-title">
            <Typography color="black" variant="h5">
              {props.title}
            </Typography>
          </div>
          <CrossIcon className="cursorHoverCSS" onClick={props.toggle} />
        </ModalHeader>
        <ModalBody>{props.children}</ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default CustomModal;
